import { capitalize } from 'lodash';

import { selectIsServiceSetup } from 'app/developer-v3/selectors';
import { useRedux } from '@zapier/toolbox-redux-framework';

const mapState = type => state => {
  return {
    [`is${capitalize(type)}Setup`]: selectIsServiceSetup(state),
  };
};

export default function useAppSummary(type: 'trigger' | 'action') {
  return useRedux(mapState(type));
}
